import React, { Component } from 'react'
import { Slider, Rail, Handles, Tracks, } from 'react-compound-slider'
//import ValueViewer from 'docs/src/pages/ValueViewer' // for examples only - displays the table above slider
import { SliderRail, Handle, Track } from './sliderSubComponents' // example render components - source below
import './slider.sass'
const sliderStyle = {
  position: 'relative',
  width: '100%',
}



class SliderComponent extends Component {
  
  
  state = {
    domain: this.props.domain,
    values: this.props.currValues.slice(),
    update: this.props.currValues.slice(),
    reversed: false,
  }

  componentDidUpdate(prevProps) {

    if(prevProps.currValues !== this.props.currValues) {
      this.setState({ values : this.props.currValues, update: this.props.currValues })
    }

  }

  onUpdate = update => {
    this.setState({ update })
    this.props.onUpdate(update)
  }

  onChange = values => {
    this.setState({ values })
    this.props.onChange(values)
}

onSlideEnd = values => {
  this.setState({ values })
  this.props.onSlideEnd(values)
}


  render() {
    const {
      state: { domain, values, reversed },
    } = this

    return (
      <div style={{ marginTop: 25, marginBottom: 75 }}>
 
        <Slider
          mode={2}
          step={this.props.steps}
          domain={domain}
          reversed={reversed}
          rootStyle={sliderStyle}
          onUpdate={this.onUpdate}
          onChange={this.onChange}
          values={values}
          onSlideEnd={this.onSlideEnd}
        >
          <Rail>
            {({ getRailProps }) => <SliderRail getRailProps={getRailProps} />}
          </Rail>
          <Handles>
            {({ handles, getHandleProps }) => (
              <div className="slider-handles">
                {handles.map(handle => (
                  <Handle
                    key={handle.id}
                    handle={handle}
                    domain={domain}
                    getHandleProps={getHandleProps}
                  />
                ))}
              </div>
            )}
          </Handles>
          <Tracks left={false} right={false}>
            {({ tracks, getTrackProps }) => (
              <div className="slider-tracks">
                {tracks.map(({ id, source, target }) => (
                  <Track
                    key={id}
                    source={source}
                    target={target}
                    getTrackProps={getTrackProps}
                  />
                ))}
              </div>
            )}
          </Tracks>
         {/*<Ticks count={10}>
            {({ ticks }) => (
              <div className="slider-ticks">
                {ticks.map(tick => (
                  <Tick key={tick.id} tick={tick} count={ticks.length} />
                ))}
              </div>
            )}
                </Ticks>*/}
        </Slider>
      </div>
    )
  }
}

export default SliderComponent


SliderComponent.defaultProps = {

    domain : [0, 100],
    currValues : [0, 100],
    onChange : function() {},
    onUpdate : function() {},
    steps : 0.1,
    onSlideEnd : function() {},

}